/**
 * Hero Landing A block script.
 *
 * Plays the page-load entrance choreography across each [data-hero-step] in
 * the hero (breadcrumb, heading, image, description), top to bottom. The
 * steps map to whichever style variant rendered (heart-image, heart-background,
 * no-heart) — the document order is correct in each case.
 */

import { entranceSequence } from '@/motion-primitives';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-hero-landing-a').forEach((hero) => {
		const steps = hero.querySelectorAll('[data-hero-step]');
		entranceSequence(Array.from(steps));
	});
});
